<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<nav class="tabs-nav {{ customClass }}">
    <a
            (click)="changeTab(tab)"
            *ngFor="let tab of tabsList; trackBy: trackByIndex"
            [ngClass]="{
            active: tab === tabsList[activeToShow],
            'tabs__nav-tab--close': showClose
        }"
            class="tabs__nav-tab tab-name-{{ tab }}"
    >
        <ng-container *ngIf="translationPrefix; else noTranslate">
            <span
                    [translateParams]="translationParamsMap?.has(tab) && translationParamsMap.get(tab)"
                    [translate]="translationPrefix + '.' + tab"
            ></span>
        </ng-container>
        <ng-template #noTranslate>
            <span>{{ tab }}</span>
        </ng-template>

        @if (showClose) {
            <button (click)="closeTab($event, tab)" class="tabs__nav-tab__close btn-no-style">
                <i aria-hidden="true">&times;</i>
            </button>
        }
    </a>
</nav>
